import type { CatalogApi } from '@backstage/plugin-catalog-react';
import type { Entity, CompoundEntityRef } from '@backstage/catalog-model';
import { stringifyEntityRef } from '@backstage/catalog-model';

function byTitleOrName(a: Entity, b: Entity): number {
  const aLabel = a.metadata.title ?? a.metadata.name;
  const bLabel = b.metadata.title ?? b.metadata.name;
  return aLabel.localeCompare(bLabel);
}

export async function fetchTenants(catalogApi: CatalogApi): Promise<Entity[]> {
  const { items } = await catalogApi.getEntities({
    filter: { kind: 'Tenant' },
  });
  return items.slice().sort(byTitleOrName);
}

export async function fetchDomainsForTenant(
  catalogApi: CatalogApi,
  tenantRef?: CompoundEntityRef,
): Promise<Entity[]> {
  const { items } = await catalogApi.getEntities({
    filter: {
      kind: 'Domain',
      ...(tenantRef ? { 'relations.partOf': stringifyEntityRef(tenantRef) } : {}),
    },
  });
  return items.slice().sort(byTitleOrName);
}

export async function fetchSystemsForDomain(
  catalogApi: CatalogApi,
  domainRef?: CompoundEntityRef,
): Promise<Entity[]> {
  const { items } = await catalogApi.getEntities({
    filter: {
      kind: 'System',
      ...(domainRef ? { 'relations.partOf': stringifyEntityRef(domainRef) } : {}),
    },
  });
  return items.slice().sort(byTitleOrName);
}
